export const UPLOAD_KNOWLEDGECENTER_DOC = "UPLOAD_KNOWLEDGECENTER_DOC"
export const UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS = "UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS"
export const UPLOAD_KNOWLEDGECENTER_DOC_FAIL = "UPLOAD_KNOWLEDGECENTER_DOC_FAIL"


export const GET_KNOWLEDGECENTER_DOC = "GET_KNOWLEDGECENTER_DOC"
export const GET_KNOWLEDGECENTER_DOC_SUCCESS = "GET_KNOWLEDGECENTER_DOC_SUCCESS"
export const GET_KNOWLEDGECENTER_DOC_FAIL = "GET_KNOWLEDGECENTER_DOC_FAIL"

// To remomve knowledge center file
export const RM_KNOWLEDGECENTER_DOC = "RM_KNOWLEDGECENTER_DOC"
export const RM_KNOWLEDGECENTER_DOC_SUCCESS = "RM_KNOWLEDGECENTER_DOC_SUCCESS"
export const RM_KNOWLEDGECENTER_DOC_FAIL = "RM_KNOWLEDGECENTER_DOC_FAIL"